import { type BoxProps, Skeleton, Stack, Text } from '@mantine/core';
import type { StatDto } from '../features/home/types/StatDto';
import { calculatePercent, isChangePositive } from '../util/calculatePercent';
import { formatToCurrency, formatToThousands } from '../util/formatting';
import { Title, type TitleProps } from './Title';

interface StatProp extends BoxProps {
	stat?: StatDto;
	data?: string;
	titleProps?: TitleProps;
	label: string;
	isFinance?: boolean;
	isLoading: boolean;
}

export function Stat({
	stat,
	data,
	isFinance = false,
	isLoading,
	label,
	titleProps,
	h = '5vh',
	...boxProps
}: StatProp) {
	return (
		<>
			<Stack align={'flex-start'} {...boxProps}>
				<Title label={label} {...titleProps} mb={0} />
				<Skeleton visible={isLoading} h={'100%'} w={'100%'}>
					<Text size={'2rem'} fw={'300'}>
						{!data ? (
							<>
								{stat &&
									(!isLoading && isFinance
										? formatToCurrency(stat?.value)
										: formatToThousands(stat?.value))}
							</>
						) : (
							<>
								{isFinance ? (
									<>{formatToCurrency(Number.parseFloat(data))}</>
								) : (
									<>{data}</>
								)}
							</>
						)}
					</Text>
					{!data && stat && (
						<Text
							c={
								isChangePositive(stat?.value, stat?.valueBefore)
									? 'green'
									: 'red'
							}
						>
							{calculatePercent(stat?.value, stat?.valueBefore)}
						</Text>
					)}
					{isLoading && (
						<>
							<Text size={'2rem'} fw={'300'}>
								Meow
							</Text>
							<Text>0</Text>
						</>
					)}
				</Skeleton>
			</Stack>
		</>
	);
}
